import { DataRoomActivityPage, DataRoomActivityRow, DataRoomActivityWindow } from 'shared';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { ApiService } from '../../../../services/index';
import { selectedCompanyStorage } from '../../../../storage/company/selected-company.util';
import { ACTIVITY_PAGE_SIZE, ActivityPages, useActivityPages } from './use-activity-pages.hook';

const roomKey = ({ dataRoomId }: DataRoomActivityRow): string => dataRoomId;

/**
 * The Data Rooms tab — 20.1.2 §2 to §4.
 *
 * Its own window and its own cache key, independent of the Overview's (§3). Nothing is computed
 * here: a row arrives counted, ordered and paged by the one read layer that defines the metrics.
 */
export const useActivityDataRooms = ({
  window,
}: {
  window: DataRoomActivityWindow;
}): ActivityPages<DataRoomActivityPage> => {
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);

  return useActivityPages({
    fetchPage: (skip: number) =>
      ApiService.get<DataRoomActivityPage>(
        { endpoint: BackendRoute.DATA_ROOM_ACTIVITY, routePath: ['data-rooms'] },
        { queryParams: { skip, take: ACTIVITY_PAGE_SIZE, window } },
      ),
    queryKey: [QueryKey.GET_DATA_ROOM_ACTIVITY_LIST, companyId, window],
    rowKey: roomKey,
    scope: [QueryKey.GET_DATA_ROOM_ACTIVITY_LIST, companyId],
  });
};
